import { render, staticRenderFns } from "./ModalArea.vue?vue&type=template&id=3823141a&"
import script from "./ModalArea.vue?vue&type=script&lang=js&"
export * from "./ModalArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports